export const pt = {
  title: 'Assinaturas',
  betterExperience:
    'Para ter uma melhor experiência de consumo dos gráficos e relatórios disponíveis, acesse pelo seu computador.',
  activeSubscriptions: {
    title: 'Assinaturas ativas',
    description:
      'Esta é a contagem total dos seus assinantes ativos e cancelados. Não inclui membros gratuitos ou produtores. Um assinante com múltiplas assinaturas referentes a vários produtos, são contados 1 vez por produto.',
  },
  contentCopiedSuccessfully: 'Copiado com sucesso',
  copyClipboard: {
    copySubscriptionId: 'Copiar ID da assinatura',
    subscriptionIdcopied: 'ID da assinatura copiado',
  },
  newSubscribers: {
    title: 'Novos assinantes',
    description: 'Total de novas assinaturas criadas durante o período selecionado.',
  },
  growth: {
    title: 'Crescimento de assinantes ativos',
    description:
      'Esta é a alteração líquida de assinantes ativos no período selecionado. Caso esse número for menor do que zero, você perdeu mais assinantes do que ganhou no período selecionado.',
  },
  canceledSubscriptions: {
    title: 'Assinaturas canceladas',
    description: 'Total de assinaturas canceladas proativamente pelos membros durante o período.',
  },
  inactiveSubscriptions: {
    title: 'Assinaturas inativadas',
    description:
      'Refere-se às assinaturas que se tornaram inativas (por cancelamento, mudança para plano gratuito, pausa ou inadimplência) dentro do intervalo da data selecionada.',
  },
  variation: 'vs. {{previous}} período anterior',
  selectPeriod: {
    hourly: 'Por hora',
    daily: 'Diário',
    weekly: 'Semanal',
    monthly: 'Mensal',
  },
  table: {
    pageSize: '{{total}} por página',
  },
  empty: 'Nenhum resultado encontrado',
  emptySubtitle: 'Ajuste seus critérios de busca ou redefina os filtros para obter mais resultados.',
  filters: {
    autocomplete: {
      noOptions: 'Não há opções disponíveis',
      loading: 'Carregando...',
      products: 'Produtos',
    },
    dateRangeBy: {
      createdAt: 'Data de criação',
      nextDueAt: 'Data de vencimento',
    },
  },
  tabs: {
    home: 'Visão geral',
    subscriptions: 'Assinaturas',
  },
  status: {
    active: 'Ativa',
    canceled: 'Cancelada',
    inactive: 'Inativa',
    incomplete: 'Incompleta',
    trial: 'Período de Teste',
  },
  exportXlsx: {
    title: 'Exportar assinaturas',
    cancel: 'Cancelar',
    confirm: 'Exportar',
    noOptions: 'Não há opções disponíveis',
    loading: 'Carregando...',
    offers: 'Produtos',
  },
  invoiceStatus: {
    pending: 'Em aberto',
    paid: 'Paga',
    expired: 'Não paga',
    refunded: 'Reembolsada',
    in_protest: 'Em protesto',
    chargeback: 'Chargeback',
  },
  planType: {
    monthly: 'Plano mensal',
    quarterly: 'Plano trimestral',
    semiannually: 'Plano semestral',
    annually: 'Plano anual',
  },
  paymentMethod: {
    credit_card: 'Cartão de crédito',
    pix: 'Pix',
  },
  actions: {
    title: '{{qnt}} assinaturas',
    deactivateBtn: 'Cancelar assinatura(s)',
    deactivateInactives: 'Você não pode cancelar assinaturas inativas.',
    deactivateCanceleds: 'Você não pode cancelar assinaturas canceladas.',
    deactivateIncompletes: 'Você não pode cancelar assinaturas que não foram pagas.',
    cannotDeactivate: 'Você não tem permissão para cancelar assinaturas.',
    addBtn: 'Estender vencimento',
    addInactives: 'Você não pode estender o vencimento de assinaturas inativas.',
    addIncompletes: 'Você não pode estender o vencimento de assinaturas que não foram pagas.',
    cannotAdd: 'Você não tem permissão para estender o vencimento de assinaturas.',
    addBtnTooltip:
      'Ao adicionar créditos diários às assinaturas selecionadas, você está postergando a data de renovação da assinatura.',
    deactivateBtnTooltip:
      'Ao cancelar as assinaturas selecionadas, elas deixarão de ser renovadas automaticamente e serão inativadas em suas datas de vencimento.',
  },
  errors: {
    general: 'Não foi possível realizar a ação',
    required: 'Campo obrigatorio',
    clipboardFailed: 'Erro ao copiar. Tente novamente mais tarde',
    credits: 'Insira somente números',
  },
  success: 'Ação realizada com sucesso!',
  datepicker: {
    placeholder: 'Data',
  },
  search: 'Buscar...',
  addDailyCreditsByEmailModal: {
    tooltip: 'Estender vencimento',
    title: 'Estender vencimento',
    description: 'Adicione créditos/dias a data de vencimento das suas assinaturas.',
    alert:
      'Ao estender a data de vencimento de assinaturas ativas, os dias adicionais serão somados à data original de término. Para assinaturas canceladas, a nova data de vencimento será ajustada, mantendo o status de cancelado. Assinaturas inativas não serão afetadas por esta ação.',
    products: 'Produto(s)',
    credits: 'Créditos/dias a serem adicionados',
    emails: 'Cliente(s)',
    emailsHelperText:
      'Para adicionar mais de um e-mail, separe cada um deles com uma vírgula. Se o e-mail não tiver acesso ao(s) produto(s) selecionado(s), ele será ignorado, e nenhum dia será adicionado.',
    cancel: 'Cancelar',
    submit: 'Estender vencimento',
    toast: {
      success: 'Sucesso ao adicionar crédito para todos os clientes selecionados.',
      emailError: 'Sucesso ao dicionar crédito para alguns clientes, mas houve erro para:',
      defaultError: 'Erro inesperado, nenhum crédito foi adicionado.',
    },
  },
}
